import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * 3-Phase Power Meter Icon Style 03 - Power
 * Power symbol icon
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:power
 */
export const Style03_Power: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-blue-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      power
    </span>
  );
};

export default Style03_Power;
